import Axios from '@/util/Axios'
import qs from 'qs';

export default {
  state:{
    loading:{
      flag:false,
      text:'',
    },
    cfg: {
      apps_options:[],
      order_status: [],
      members_options:[],
      font_options:[],
    },
    current_menu:null,
    current_menu_sub:null,
    // font_options: [
    //   { index: "01", font_label0: "MrDeHaviland Regular", font_name: "mrdehaviland-regular", font_label: "Vintage Master", scan: 1 },
    //   { index: "02", font_label0: "Corinthia Bold", font_name: "corinthia-bold", font_label: "Classic Luxe", scan: 1 },
    //   { index: "03", font_label0: "Corinthia Regular", font_name: "corinthia-regular", font_label: "Refined Silk", scan: 1 },
    //   { index: "04", font_label0: "FuzzyBubbles Regular", font_name: "fuzzybubbles-regular", font_label: "Cloudy Charm", scan: 1 },
    //   { index: "05", font_label0: "TwinkleStar Regular", font_name: "twinklestar-regular", font_label: "Starry Night", scan: 1 },
    //   { index: "06", font_label0: "WindSong Medium", font_name: "windsong-medium", font_label: "Serene Melody", scan: 1 },
    //   { index: "07", font_label0: "WindSong Regular", font_name: "windsong-regular", font_label: "Airy Echo", scan: 1 },
    //   { index: "08", font_label0: "Italianno Regular", font_name: "italianno-regular", font_label: "Florence Luxe", scan: 1 },
    //   { index: "09", font_label0: "LeagueScript Regular", font_name: "leaguescript-regular", font_label: "Delicate Muse", scan: 1 },
    //   { index: "10", font_label0: "PlaywriteAR VariableFont wght", font_name: "playwritear-variablefont_wght", font_label: "Poetic Flow", scan: 1 },
    //   { index: "11", font_label0: "QwitcherGrypen Bold", font_name: "qwitchergrypen-bold", font_label: "Bold Artisan", scan: 1 },
    //   { index: "12", font_label0: "QwitcherGrypen Regular", font_name: "qwitchergrypen-regular", font_label: "Rapid Signature", scan: 1 },
    //   { index: "13", font_label0: "Whisper Regular", font_name: "whisper-regular", font_label: "Velvet Breath", scan: 1 },
    //   { index: "14", font_label0: "Yellowtail Regular", font_name: "yellowtail-regular", font_label: "Retro Pulse", scan: 1 },
    //   { index: "15", font_label0: "BilboSwashCaps Regular", font_name: "bilboswashcaps-regular", font_label: "Vogue Script", scan: 1 },
    //   { index: "16", font_label0: "Bonbon Regular", font_name: "bonbon-regular", font_label: "Playful Sweet", scan: 1 },
    //   { index: "17", font_label0: "ButterflyKids Regular", font_name: "butterflykids-regular", font_label: "Whimsical Joy", scan: 1 },
    //   { index: "18", font_label0: "Calligraffitti Regular", font_name: "calligraffitti-regular", font_label: "Urban Artist", scan: 1 },
    //   { index: "19", font_label0: "Caveat VariableFont wght", font_name: "caveat-variablefont_wght", font_label: "Modern Casual", scan: 1 },
    //   { index: "20", font_label0: "ChangaOne Italic", font_name: "changaone-italic", font_label: "Dynamic Bold", scan: 1 },
    //   { index: "21", font_label0: "Charmonman Bold", font_name: "charmonman-bold", font_label: "Royal Majestic", scan: 1 },
    //   { index: "22", font_label0: "Charmonman Regular", font_name: "charmonman-regular", font_label: "Exotic Grace", scan: 1 },
    //   { index: "23", font_label0: "ElmsSans Italic VariableFont wght", font_name: "elmssans-italic-variablefont_wght", font_label: "Active Minimal", scan: 1 },
    //   { index: "24", font_label0: "Festive Regular", font_name: "festive-regular", font_label: "Holiday Spirit", scan: 1 },
    //   { index: "25", font_label0: "Fuggles Regular", font_name: "fuggles-regular", font_label: "Artisan Flare", scan: 1 },
    //   { index: "26", font_label0: "FuzzyBubbles Bold", font_name: "fuzzybubbles-bold", font_label: "Soft Statement", scan: 1 },
    //   { index: "27", font_label0: "GiveYouGlory Regular", font_name: "giveyouglory-regular", font_label: "Pure Glory", scan: 1 },
    //   { index: "28", font_label0: "GrapeNuts Regular", font_name: "grapenuts-regular", font_label: "Organic Touch", scan: 1 },
    //   { index: "29", font_label0: "IngridDarling Regular", font_name: "ingriddarling-regular", font_label: "Darling Script", scan: 1 },
    //   { index: "30", font_label0: "MeowScript Regular", font_name: "meowscript-regular", font_label: "Chic Meow", scan: 1 },
    //   { index: "31", font_label0: "MrsSaintDelafield Regular", font_name: "mrssaintdelafield-regular", font_label: "Heritage Sign", scan: 1 },
    //   { index: "32", font_label0: "OoohBaby Regular", font_name: "ooohbaby-regular", font_label: "Sweet Darling", scan: 1 },
    //   { index: "33", font_label0: "Qwigley Regular", font_name: "qwigley-regular", font_label: "Elegance Curve", scan: 1 },
    //   { index: "34", font_label0: "Rancho Regular", font_name: "rancho-regular", font_label: "Rustic Soul", scan: 1 },
    //   { index: "35", font_label0: "Schoolbell Regular", font_name: "schoolbell-regular", font_label: "Naive Heart", scan: 1 },
    //   { index: "36", font_label0: "Shalimar Regular", font_name: "shalimar-regular", font_label: "Silk Whisper", scan: 1 },
    //   { index: "37", font_label0: "SwankyandMooMoo Regular", font_name: "swankyandmoomoo-regular", font_label: "Studio Quirky", scan: 1 },
    //   { index: "38", font_label0: "Waterfall Regular", font_name: "waterfall-regular", font_label: "Fluid Motion", scan: 1 },
    // ],
  },
  mutations:{
    setLoading(state,n){
      if (n.text) {
        state.loading.flag = true;
        state.loading.text = n.text;
      } else {
        state.loading.flag = false;
      }
    },
    set_current_menu(state,n){
      state.current_menu = n.name;
    },
    set_current_menu_sub(state,n){
      state.current_menu_sub = n.name;
    },
    setCfgOptions(state, data) {
        state.cfg = data;
        if (data.font_options) {
            const styleId = 'casedraw-dynamic-fonts';
            let styleTag = document.getElementById(styleId);
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = styleId;
                document.head.appendChild(styleTag);
            }

            let cssRules = '';
            data.font_options.forEach(font => {
                cssRules += `
                    @font-face {
                        font-family: '${font.font_name}';
                        src: url('${font.font_path}') format('truetype');
                        font-display: swap; 
                    }
                `;
            });
            styleTag.textContent = cssRules;
        }
    },


  },
  actions:{
    getCfgOptions(context){
      Axios.post('/v1/pub/helpers/cfg-options', {})
        .then(function (response) {
          var res = response.data;
          if (res.code == 1) {
            context.commit('setCfgOptions', res.data);
            context.commit('setCfgOptions', res.data);
          }
        })
    },
  }


}



// WEBPACK FOOTER //
// ./src/vuex/modules/public/index.js